export default __webpack_public_path__ + "static/media/client4.c1557872.png";